import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        count: 0,
        maproom: "",
        speaker: {},
        conferencename: "Øredev 2024",
        docimage:
            "https://res.cloudinary.com/oredev/image/upload/v1648207793/2022_web/%C3%98redev_2019_d0ogfz.png",
        sessions: [],
        speakers: [],
        tracks: [],
        grid: [],
        all: [],
        effect: false
    },
    getters,
    mutations,
    actions
});


// WEBPACK FOOTER //
// ./src/store/index.js